import defaultSearchConfiguration from './default-search-configuration';
import './page/topdata-reg-attempt-log-list';
import './page/topdata-reg-attempt-log-detail';
import enGB from './snippet/en-GB';
import deDE from './snippet/de-DE';

const { Module } = Shopware;

Module.register('topdata-contact-login-reg-log', {
    snippets: {
        'en-GB': enGB,
        'de-DE': deDE,
    },
    type: 'plugin',
    name: 'TopdataContactLoginSW6.regLog.module.name',
    title: 'TopdataContactLoginSW6.regLog.module.title',
    description: 'TopdataContactLoginSW6.regLog.module.description',
    color: '#e91e63',
    icon: 'regular:shield',

    entity: 'tdcl_registration_attempt_log',

    routes: {
        list: {
            component: 'topdata-reg-attempt-log-list',
            path: 'list',
        },
        detail: {
            component: 'topdata-reg-attempt-log-detail',
            path: 'detail/:id',
        },
    },

    navigation: [{
        id: 'topdata-contact-login-reg-log',
        label: 'TopdataContactLoginSW6.regLog.module.title',
        color: '#e91e63',
        icon: 'regular:shield',
        path: 'topdata.contact.login.reg.log.list',
        parent: 'sw-customer',
        position: 110,
    }],

    defaultSearchConfiguration,
});
